import {
  Paper,
  Typography,
  Box,
  TextField,
  InputAdornment,
  FormControlLabel,
  Checkbox,
  Tooltip,
  Grid
} from "@mui/material";

import InfoIcon from "@mui/icons-material/Info";

export default function DatosReciboCard({
  totalEsperado,
  onTotalEsperadoChange,
  FechaDePago,
  onFechaChange,
  numRecibo,
  onNumReciboChange,
  usaReciboElectronico,
  onReciboElectronicoChange,
  handleImporteChange,
  gridSize,
  spacing
}) {

  return (
    <Paper elevation={2} sx={{ p: 2 }}>
      <Grid container spacing={spacing || 1} alignItems="flex-end" justifyContent="space-between">
        <Grid item xs={12}>
          <Typography
            variant="subtitle2"
            fontWeight="bold"
            gutterBottom
            color="primary"
          >
            Datos del Recibo
          </Typography>
        </Grid>

        {/* Total esperado */}
        <Grid item xs={12} md={12} lg={gridSize || 12}>
          <TextField
            onWheel={(e) => e.target.blur()}
            sx={{
              "& input[type=number]": {
                MozAppearance: "textfield", // Firefox
              },
              "& input[type=number]::-webkit-outer-spin-button": {
                WebkitAppearance: "none",
                margin: 0,
              },
              "& input[type=number]::-webkit-inner-spin-button": {
                WebkitAppearance: "none",
                margin: 0,
              },
            }}
            label="Total esperado "
            type="number"
            value={totalEsperado}
            onChange={(e) => handleImporteChange(e, onTotalEsperadoChange)}
            size="small"
            fullWidth
            required
            error={!totalEsperado || parseFloat(totalEsperado || 0) <= 0}
            InputProps={{
              startAdornment: <InputAdornment position="start">$</InputAdornment>,
            }}
          />
        </Grid>

        {/* fecha de pago */}
        <Grid item xs={12} md={12} lg={gridSize || 12}>
          <Box display="flex" alignItems="center" gap={0.5}>
            <Typography
              variant="caption"
              color="text.secondary"
              display="block"
              mb={0.5}
            >
              fecha de pago *
            </Typography>
            <Tooltip
              title={
                <>
                  Fecha informativa del pago.{" "}
                  <Typography component="span" fontWeight="bold" fontSize={12}>
                    No afecta la contabilidad.
                  </Typography>{" "}
                </>
              }
            >
              <span>
                <InfoIcon fontSize="small" color="action" />
              </span>
            </Tooltip>
          </Box>
          <Box sx={{ display: "flex", gap: 0.5 }}>
            <TextField
              placeholder="DD"
              value={FechaDePago.dia}
              onChange={(e) => {
                const value = e.target.value;

                if (/^\d*$/.test(value)) {
                  onFechaChange("dia", value);
                }
              }}
              size="small"
              required
              inputProps={{ maxLength: 2, style: { textAlign: "center" } }}
              sx={{ width: 60 }}
            />
            <TextField
              placeholder="MM"
              value={FechaDePago.mes}
              onChange={(e) => {
                const value = e.target.value;

                if (/^\d*$/.test(value)) {
                  onFechaChange("mes", value);
                }
              }}
              size="small"
              required
              inputProps={{ maxLength: 2, style: { textAlign: "center" } }}
              sx={{ width: 60 }}
            />
            <TextField
              placeholder="AAAA"
              value={FechaDePago.ano}
              onChange={(e) => {
                const value = e.target.value;

                if (/^\d*$/.test(value)) {
                  onFechaChange("ano", value);
                }
              }}
              size="small"
              required
              inputProps={{ maxLength: 4, style: { textAlign: "center" } }}
              sx={{ flex: 1 }}
            />
          </Box>
        </Grid>

        {/* Punto de venta y número en una fila */}
        <Grid item  xs={12} md={12} lg={gridSize || 12} >
          <Box sx={{ display: "flex", gap: 0.5 }}>
            <TextField
              label="Punto de Venta"
              value={numRecibo.ptoVta}
              inputProps={{ maxLength: 6 }}
              onChange={(e) => {
                const value = e.target.value;

                if (/^\d*$/.test(value)) {
                  onNumReciboChange("ptoVta", value);
                }
              }}
              size="small"
              required
              sx={{ flex: 1 }} 
            />
            <TextField
              label="Número (opcional)"
              value={numRecibo.numero}
              inputProps={{ maxLength: 8 }}
              onChange={(e) => {
                const value = e.target.value;

                if (/^\d*$/.test(value)) {
                  onNumReciboChange("numero", value);
                }
              }}
              size="small"
              sx={{ flex: 2 }} 
            />
          </Box>
        </Grid>

        {/* Recibo electrónico */}
        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Checkbox
                checked={usaReciboElectronico}
                onChange={(e) => onReciboElectronicoChange(e.target.checked)}
                size="small"
              />
            }
            label={<Typography variant="body2">Recibo electrónico</Typography>}
          />
        </Grid>
      </Grid>
    </Paper>
  );
}
